import { Stack } from '@mui/material'
import React from 'react'
import { Chukker, Chukkers, ChukkerWithoutMetaFields, excludedKeys } from '../../shared/types/chukkers.type'
import I18nDataGrid from '../global/I18nDataGrid'
import { GridColDef } from '@mui/x-data-grid'
import { capitalize, isEmpty, omit, uniqueId } from 'lodash'
import { t } from 'i18next'
import { formatValueBasedOnChukkerKeyUnit, getUnitForChukkerKey } from '../../shared/utils/myTrainings'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'
import { useAuth } from '../../hooks/useAuth'
import { useChukkerTranslation } from '../../hooks/useChukkerTranslation'


type ChukkersAnalysisProps = {
    chukkers?: Chukkers
}

function ChukkersAnalysis({ chukkers }: ChukkersAnalysisProps) {

    const { getSpeedUnit } = useAuth()

    const { getTranslationByKey, enabledKeys } = useChukkerTranslation()

    const metric = useSelector<RootState>(state => state.user.user?.unit_system) as "metric" | "imperial"




    const getChukkersHeaders = (): GridColDef[] => {
        if (!chukkers) return []
        return chukkers.map((c, index) => {
            return {
                field: `key-${c.id}`,
                headerName: `Chukker ${index + 1}`,
                flex: 1,
                sortable: false,

            }
        })
    }



    const columns: GridColDef[] = [
        {
            field: 'title',
            headerName: '',
            sortable: false,
            flex: 1
        },
        ...getChukkersHeaders()
    ]



    const getKeysFromChukker = (chukker: Chukker) => {

        const _chukker: ChukkerWithoutMetaFields = omit(chukker, excludedKeys) as ChukkerWithoutMetaFields;

        let keys = Object.keys(_chukker)

        return keys.map(key => key) as (keyof Chukker)[];


    }

    const getChukkersRows = () => {
        if (!chukkers || isEmpty(chukkers)) return [];

        // Ensure keys are typed as keyof Chukker[]
        // const keys = randomChuker ? getKeysFromChukker(randomChuker) as (keyof Chukker)[] : [];

        console.log({chukkers});
        
        if (isEmpty(enabledKeys)) return [];

        return enabledKeys.map((key) => {
            const obj: Record<string, any> = {};

            let userSpeedUnit = getSpeedUnit()?.value ?? ""

            const unit = getUnitForChukkerKey(key, metric) ? `${getUnitForChukkerKey(key, metric)}` : ""

            chukkers.forEach((chukker) => {

                const value = chukker[key];

                const formattedValue = formatValueBasedOnChukkerKeyUnit(value, key, metric, userSpeedUnit)

                obj[`key-${chukker.id}`] = formattedValue ? String(formattedValue).concat(` ${unit}`) : "";
            });


            return {
                title: getTranslationByKey(key), // safe cast
                ...obj
            };
        });
    };






    return (
        <Stack id='chukker-section' direction={'column'} spacing={2}>
            <I18nDataGrid
                columns={columns}
                rows={getChukkersRows()}
                disableColumnMenu
                disableColumnFilter
                disableRowSelectionOnClick
                getRowId={row => row.title}
                hideFooterPagination={true}
                getRowClassName={() => 'interval_row'}
            />
        </Stack>
    )
}

export default ChukkersAnalysis